import img1 from "./1.jpg";
import img2 from "./2.jpg";
import img3 from "./3.jpg";
import img4 from "./4.jpg";
import img5 from "./5.jpg";
import img6 from "./6.jpg";
import img7 from "./7.jpg";
import img8 from "./8.jpg";
import img9 from "./9.jpg";
import img10 from "./10.jpg";
import img11 from "./11.jpg";
import img12 from "./12.jpg";
import img13 from "./13.jpg";
import img14 from "./14.jpg";
import img15 from "./15.jpg";
import img16 from "./16.jpg";
import img17 from "./17.jpg";
import img18 from "./18.jpg";
import img19 from "./19.jpg";
import img20 from "./20.jpg";
import img21 from "./21.jpg";

const imagesGallery = [
  {
    id: 1,
    src: img1,
    title: "foo",
    description: "bar"
  },
  {
    id: 2,
    src: img2,
    title: "foo",
    description: "bar"
  },
  {
    id: 3,
    src: img3,
    title: "foo",
    description: "bar"
  },
  {
    id: 4,
    src: img4,
    title: "foo",
    description: "bar"
  },
  {
    id: 5,
    src: img5,
    title: "foo",
    description: "bar"
  },
  {
    id: 6,
    src: img6,
    title: "foo",
    description: "bar"
  },
  {
    id: 7,
    src: img7,
    title: "foo",
    description: "bar"
  },
  {
    id: 8,
    src: img8,
    title: "foo",
    description: "bar"
  },
  {
    id: 9,
    src: img9,
    title: "foo",
    description: "bar"
  },
  {
    id: 10,
    src: img10,
    title: "foo",
    description: "bar"
  },
  {
    id: 11,
    src: img11,
    title: "foo",
    description: "bar"
  },
  {
    id: 12,
    src: img12,
    title: "foo",
    description: "bar"
  },
  {
    id: 13,
    src: img13,
    title: "foo",
    description: "bar"
  },
  {
    id: 14,
    src: img14,
    title: "foo",
    description: "bar"
  },
  {
    id: 15,
    src: img15,
    title: "foo",
    description: "bar"
  },
  {
    id: 16,
    src: img16,
    title: "foo",
    description: "bar"
  },
  {
    id: 17,
    src: img17,
    title: "foo",
    description: "bar"
  },
  {
    id: 18,
    src: img18,
    title: "foo",
    description: "bar"
  },
  {
    id: 19,
    src: img19,
    title: "foo",
    description: "bar"
  },
  {
    id: 20,
    src: img20,
    title: "foo",
    description: "bar"
  },
  {
    id: 21,
    src: img21,
    title: "foo",
    description: "bar"
  }
];

export default imagesGallery;
